import React from 'react';
import { Box, Container, Typography, Stack, IconButton } from '@mui/material';
import { FaFacebook, FaInstagram, FaTiktok } from 'react-icons/fa';
import { Link as ScrollLink } from 'react-scroll';

const navLinks = [
  { id: 'process', label: 'Cómo trabajamos' },
  { id: 'portfolio', label: 'Portafolio' },
  { id: 'services', label: 'Servicios' },
  { id: 'about', label: 'Nosotros' },
  { id: 'contact', label: 'Contacto' },
];

const socials = [
  {
    icon: <FaFacebook size={20} />,
    href: 'https://www.facebook.com/profile.php?id=61576406523910',
    hoverColor: '#1877F2',
  },
  {
    icon: <FaInstagram size={20} />,
    href: 'https://www.instagram.com/effsos_app/',
    hoverColor: '#E1306C',
  },
  {
    icon: <FaTiktok size={20} />,
    href: 'https://www.tiktok.com/@effsos_',
    hoverColor: '#ff0050',
  },
];

const Footer = () => {
  return (
    <Box sx={{ bgcolor: '#083a94', color: 'white', pt: 8, pb: 4 }}>
      <Container maxWidth="lg">
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={6} justifyContent="space-between" mb={6}>

          {/* Marca */}
          <Box sx={{ maxWidth: 300 }}>
            <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
              Effsos
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.9rem', lineHeight: 1.7, mb: 3 }}>
              Diseñamos e implementamos soluciones de software a medida para pequeñas
              empresas. Sin plantillas. Sin intermediarios.
            </Typography>
            <Stack direction="row" spacing={1}>
              {socials.map((s, i) => (
                <IconButton
                  key={i}
                  component="a"
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: 'rgba(255,255,255,0.6)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    borderRadius: 2,
                    transition: 'color 0.2s, border-color 0.2s, transform 0.2s',
                    '&:hover': {
                      color: s.hoverColor,
                      borderColor: s.hoverColor,
                      transform: 'translateY(-2px)',
                    },
                  }}
                >
                  {s.icon}
                </IconButton>
              ))}
            </Stack>
          </Box>

          {/* Navegación */}
          <Box>
            <Typography sx={{ fontWeight: 700, mb: 2, fontSize: '0.85rem', letterSpacing: 1.5, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase' }}>
              Navegación
            </Typography>
            <Stack spacing={1}>
              {navLinks.map(({ id, label }) => (
                <ScrollLink key={id} to={id} smooth duration={500} offset={-70} style={{ cursor: 'pointer' }}>
                  <Typography
                    sx={{
                      color: 'rgba(255,255,255,0.7)',
                      fontSize: '0.92rem',
                      cursor: 'pointer',
                      transition: 'color 0.2s',
                      '&:hover': { color: '#38BDF8' },
                    }}
                  >
                    {label}
                  </Typography>
                </ScrollLink>
              ))}
            </Stack>
          </Box>

          {/* Contacto */}
          <Box>
            <Typography sx={{ fontWeight: 700, mb: 2, fontSize: '0.85rem', letterSpacing: 1.5, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase' }}>
              Contacto
            </Typography>
            <Stack spacing={1}>
              <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.92rem' }}>
                WhatsApp: +57 315 8497136
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.92rem' }}>
                Colombia
              </Typography>
            </Stack>
          </Box>

        </Stack>

        <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', pt: 3, textAlign: 'center' }}>
          <Typography sx={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.82rem' }}>
            © {new Date().getFullYear()} Effsos. Todos los derechos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
